/**
 * Test category mapping utilities
 * Centralized logic for filtering and categorizing tests
 */

// Flow map: maps test flow types to their component test types
export const flowMap = {
  "fsc": ["t", "c"],
  "fspb": ["t", "a"],
  "fscp": ["t", "c", "a"],
  "fspc": ["t", "c", "a"],
  "fspc20": ["t", "c", "a"],
  "fscc": ["t", "o", "c"],
  "rs": ["t"],
  "rpnb": ["p", "b"],
  "ro": ["o"],
};

/**
 * Normalizes test type abbreviations
 * @param {string} tt - Test type to normalize
 * @returns {string} Normalized test type
 */
export const normalizeTestType = (tt) => {
  if (!tt) return tt;
  const s = String(tt).toLowerCase();
  if (s === "qt") return "t";
  if (s === "qc") return "c";
  if (s === "qa") return "a";
  return s;
};

/**
 * Filters tests for a specific category
 * @param {Array} tests - Array of test objects
 * @param {string} categoryId - Category ID ('t', 'c', 'p', 'b', 'o')
 * @returns {Array} Filtered array of tests for the category
 */
export const getTestsForCategory = (tests, categoryId) => {
  const safeTests = Array.isArray(tests) ? tests : [];
  return safeTests.filter((test) => {
    const testedType = normalizeTestType(test.test_type);
    const rawType = String(test.test_type || '').toLowerCase();
    const flowTypes = flowMap[rawType] || [];

    if (categoryId === "t") {
      return testedType === "t" || flowTypes.includes("t");
    } else if (categoryId === "c") {
      return testedType === "c" || flowTypes.includes("c");
    } else if (categoryId === "p") {
      return testedType === "p" || testedType === "a" || flowTypes.includes("p");
    } else if (categoryId === "b") {
      return testedType === "b" || testedType === "a" || flowTypes.includes("b");
    } else if (categoryId === "o") {
      return testedType === "o" || flowTypes.includes("o");
    } else if (categoryId === "apt") {
      return testedType === "apt" || flowTypes.includes("apt");
    }
    return false;
  });
};
